export default __webpack_public_path__ + "static/media/CSlogo.451f335b.svg";